// extracted by mini-css-extract-plugin
export var navbarSubLink = "w_f6 d_f6 d_f0 d_X d_b8 d_dj d_bp d_bQ";
export var menuLink = "w_qY d_fX d_dx";
export var subPageLink = "w_gb d_gb d_dn d_dr";
export var subPageLinkColor = "w_gc d_gc";
export var burgerItemSmall = "w_sj d_f9 d_W d_bq";
export var Link = "w_qZ v_qZ v_q1 v_rl";